import { FC, useEffect } from "react";
import { connectStateResults } from "react-instantsearch-dom";
import { StateResultsProvided, AlgoliaError } from "react-instantsearch-core";

interface ErrorProps extends StateResultsProvided {
  onError: () => void;
  error: Error;
}

interface Error extends AlgoliaError {
  status: number;
}

const Error: FC<ErrorProps> = ({ error, onError }) => {
  useEffect(() => {
    if (error?.status === 400) {
      onError();
    }
  }, [error]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

const SearchError = connectStateResults(Error);

export { SearchError };
